export class DateUtils {
  /**
   * Converts the given date to the format
   * `dd.MM.yyyy_HH-mm-ss`
   * @param date
   * @returns
   */
  public static getStringDate(date: Date): string {
    const dateString =
      ("0" + date.getDate()).slice(-2) +
      "." +
      ("0" + (date.getMonth() + 1)).slice(-2) +
      "." +
      date.getFullYear() +
      "_" +
      ("0" + date.getHours()).slice(-2) +
      "_" +
      ("0" + date.getMinutes()).slice(-2) +
      "_" +
      ("0" + date.getSeconds()).slice(-2);

    return dateString;
  }

  /**
   * Converts the given date to the format `yyyy-MM-dd`
   */
  public static getDatePart(date: Date): string {
    return (
      date.getFullYear() +
      "-" +
      ("0" + (date.getMonth() + 1)).slice(-2) +
      "-" +
      ("0" + date.getDate()).slice(-2)
    );
  }

  /**
   * Expects a date string in the format `yyyy-MM-dd` and time string in the format `HH:mm`.
   * @returns ISO 8601 formatted string with local timezone offset (e.g., `2025-01-15T09:30:00+02:00`).
   */
  public static combineDateAndTimeStrings(date: string, time: string): string {
    const dateParts = date.split("-");
    const timeParts = time.split(":");
    const combinedDate = new Date(
      +dateParts[0],
      +dateParts[1] - 1,
      +dateParts[2],
      +timeParts[0],
      +timeParts[1],
    );

    return this.toISOStringWithTimezone(combinedDate);
  }

  /**
   * Converts a Date to ISO 8601 formatted string with local timezone offset.
   * @returns ISO 8601 formatted string (e.g., `2025-01-15T09:30:00+02:00`).
   */
  public static toISOStringWithTimezone(date: Date): string {
    if (isNaN(date.getTime())) {
      throw new Error("Invalid date");
    }

    const pad = (n: number) => String(n).padStart(2, "0");

    // Build local date/time string (not UTC)
    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1);
    const day = pad(date.getDate());
    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());
    const seconds = pad(date.getSeconds());

    const localDateTime = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;

    // Calculate timezone offset
    const offset = date.getTimezoneOffset();
    const sign = offset > 0 ? "-" : "+";
    const offsetHours = pad(Math.floor(Math.abs(offset) / 60));
    const offsetMinutes = pad(Math.abs(offset) % 60);

    return `${localDateTime}${sign}${offsetHours}:${offsetMinutes}`;
  }
}
